import React from "react";

const tone = (v) => (v >= 0 ? "text-[#2CF6B3]" : "text-[#FF3D68]");

const Tile = ({ a, i }) => (
  <div className="fc-panel p-[0.55em] min-w-0 flex flex-col gap-[0.2em] overflow-hidden" data-testid={`tv-alert-${i}`}>
    <div className="flex items-baseline gap-[0.5em]">
      <b className="nx-orbitron text-[1.5em] text-cyan-50">{a.symbol}</b>
      {a.held && <span className="fc-label text-[#00F0FF]">HELD</span>}
      <span className={`nx-orbitron text-[1.4em] font-black ${tone(a.change_pct)}`}>{a.change_pct >= 0 ? "+" : ""}{a.change_pct}%</span>
      <span className="fc-num ml-auto text-cyan-100/80">${a.price}</span>
    </div>
    <p className="fc-num text-[0.95em]"><b className={a.volume_ratio >= 2 ? "text-amber-300" : "text-cyan-200/70"}>{a.volume_ratio}x avg volume</b>
      <span className="text-cyan-200/60"> · 50d {a.vs_50 || "--"} · 200d {a.vs_200 || "--"}</span></p>
    <p className="fc-num text-[0.9em] text-amber-200/90 line-clamp-2">WATCH: {a.watch}</p>
    {a.ai && <p className="text-[0.9em] text-cyan-50/80 italic line-clamp-2">{a.ai}</p>}
  </div>
);

export const FloorTvAlerts = ({ d }) => (
  <div className="min-h-0 min-w-0 h-full flex flex-col gap-[0.5em] overflow-hidden" data-testid="tv-alerts-screen">
    <div className="flex items-baseline gap-[0.8em]">
      <p className="nx-orbitron text-[2em] font-black tracking-[0.2em] text-[#00F0FF]">EXPLAINED ALERTS</p>
      <p className="fc-num text-cyan-200/70">held + top movers · why it moved · where it sits · what to watch{d?.ts ? ` · updated ${new Date(d.ts).toLocaleTimeString("en-US", { timeZone: "America/Chicago", hour: "numeric", minute: "2-digit" })} CT` : ""}</p>
    </div>
    <div className="grid grid-cols-4 gap-[0.5em] min-h-0 flex-1 content-start overflow-hidden">
      {(d?.alerts || []).slice(0, 16).map((a, i) => <Tile key={a.symbol} a={a} i={i} />)}
      {!d?.alerts?.length && <p className="fc-num text-cyan-200/60">No alerts yet — refreshes every 15 min, 08:30–15:00 CT.</p>}
    </div>
  </div>
);
